import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useMediaGalleryList() {
    const { t } = useI18nUtils()
    const tableColumns = [
        { key: '', label: '', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'file_type', label: 'File Type', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const typeFilter = ref(null)
    const statusFilter = ref(null)
    const toast = useToast()
    const isMediaFormSidebarActive = ref(false)
    const mediaGalleries = ref([])
    const mediaGalleryData = ref(null)
    const typeData = ref(null)
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const searchQuery = ref('')
    const currentPage = ref(1)
    const perPage = ref(10)
    const totalMediaGalleries = ref(0)
    const refMediaListTable = ref(null)
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const dataMeta = computed(() => {
        const from = Math.max(1, perPage.value * (currentPage.value - 1) + 1);
        const to = Math.min(
            totalMediaGalleries.value,
            perPage.value * currentPage.value
        );
        return {
            from,
            to,
            of: totalMediaGalleries.value,
        }
    })

    store.dispatch('app-media/getMediaTypes')
        .then(response => {
            typeData.value = response.data.data
        })

    const updateOrdering = () => {
        const filteredData = mediaGalleries.value?.filter(item => item !== undefined);

        store.dispatch('app-media/updateOrdering', filteredData)
    }

    const refetchData = () => {
        fetchData()
    }

    watch([currentPage, perPage, searchQuery, statusFilter, typeFilter], () => {
        fetchData()
    })

    const resolveStatusVariant = status =>{
        if (status) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const updateMedia = async (data) => {
        if(data) {
            mediaGalleryData.value = data
        } else {
            mediaGalleryData.value = null
        }

        isMediaFormSidebarActive.value = true
    }

    const fetchData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store.dispatch(`app-media/getMediaGalleries`, {
            limit: perPage.value,
            offset: offset,
            keywords: searchQuery.value,
            order_by: 'ordering_count DESC',
            type_id: typeFilter.value,
            sites_id: getLocalSite.id
        })
        .then(response => {
            mediaGalleries.value = response.data.data
            totalMediaGalleries.value = response.data.total
        })
        .catch(() => {
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error fetching media' lists",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    const deleteData = (id) => {
        store.dispatch('app-media/deleteMedia',id).then(response=>{
            toast({
                component: ToastificationContent,
                props: {
                title: "Delete Success",
                icon: 'AlertTriangleIcon',
                variant: 'success',
                },
            })
            
            fetchData();
        }).catch((error)=>{
            toast({
                component: ToastificationContent,
                props: {
                    title: "Error Delete Food Category",
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                },
            })
        })
    }

    return {
        t,
        tableColumns,
        updateMedia,
        dataMeta,
        currentPage,
        perPage,
        totalMediaGalleries,
        refMediaListTable,
        searchQuery,
        isSortDirDesc,
        sortBy,
        mediaGalleries,
        isMediaFormSidebarActive,
        refetchData,
        fetchData,
        mediaGalleryData,
        resolveStatusVariant,
        resolveStatusnameVariant,
        statusFilter,
        typeFilter,
        typeData,
        updateOrdering,
        deleteData,
    }
}